import React from "react";
import { createRoot } from "react-dom";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/footer";
import CookieB from "./components/cookieBanner.js";
import "./App.css";

import { routesConfig } from "./routesConfig";

const AppLayout = () => (
  <>
    <Navbar />
    <CookieB />
    <Routes>
      {routesConfig.map((r) => (
        <Route key={r.path} path={r.path} element={r.element} />
      ))}
    </Routes>
    <Footer />
  </>
);

function ScrollToTop() {
  const location = useLocation();
  React.useEffect(() => window.scrollTo(0, 0), [location]);
  return null;
}

createRoot(document.getElementById("root")).render(
  <Router>
    <ScrollToTop />
    <AppLayout />
  </Router>
);